export enum HalalEdaPageSection {
  Orders = 'orders',
  Menu = 'menu',
  Establishment = 'establishment',
  Statistics = 'statistics',
  Stock = 'stock',
}
